import type AttachmentItemsPagingMetadata from 'owa-service/lib/contract/AttachmentItemsPagingMetadata';

export interface OneDriveItemsSkipTokenPagingMetadata extends AttachmentItemsPagingMetadata {
    __type: 'OneDriveItemSkipTokenPagingMetadata:#Client';
    skipToken: string;
    totalItemsFetched: number;
}

export function oneDriveItemsSkipTokenPagingMetadata(
    metadata: Pick<
        OneDriveItemsSkipTokenPagingMetadata,
        Exclude<keyof OneDriveItemsSkipTokenPagingMetadata, '__type'>
    >
): OneDriveItemsSkipTokenPagingMetadata {
    return { ...metadata, __type: 'OneDriveItemSkipTokenPagingMetadata:#Client' };
}
